// extracted by mini-css-extract-plugin
module.exports = {"borderGrey":"#B5B4B5","zIndexModalBackdrop":"1040","question":"_13AamW0sHp4woXbZ","text":"_2ptSiVIWET3vNuvK"};